import { getRandomString } from '@/helpers/helpers.js'
import axios from 'axios'

export const uploadFilesMixin = {
  data() {
    return {
      files: [],
      uploadStartingFromIndex: 0
    }
  },

  methods: {
    // Это входной метод для аплоуда файлов. Именно он вызывается с кнопки Add file.
    // В него передается индекс после которого будет добавляться Инфопара
    // Если добавляяем в начало поста то передаем 0
    addFiles(index) {
      this.uploadStartingFromIndex = index
      // В темплейте компонента использующего этот миксин обяязательно должен быть
      // компонент InputFileHidden, и на него надо не забыть повесить ref=files
      this.$refs.files.click()
    },
    async getFilePreview(file) {
      console.log('get file preview start:', file.name)
      file.uploadStatus = 'creating_preview'
      this.updateProperties(file)

      let reader = new FileReader()
      console.log('FILE:', file)
      console.log('FILE type1:', file.type)
      console.log('FILE type2:', file.file.type)
      file.type = file.file.type
      this.updateProperties(file)
      return new Promise(resolve => {
        // eslint-disable-next-line no-unused-vars
        reader.onload = event => {
          let previewingFile = file
          let fileSrc = reader.result
          //let filetype = fileSrc.split(':')[1].split(';')[0]
          //previewingFile.type = filetype
          if (previewingFile.type.indexOf('image') >= 0) {
            const img = new Image()
            img.addEventListener('load', () => {
              file.width = img.width
              file.height = img.height
            })
            img.src = reader.result
          }
          previewingFile.preview = fileSrc
          file.uploadStatus = 'preview_created'
          this.updateProperties(file)
          resolve()
        }
        console.log('SIZE:', file.file.size)
        if (file.file.size < 100000000) {
          reader.readAsDataURL(file.file)
        }
      })
    },
    previewsQueue(concurrency = 1) {
      let running = 0
      const filesQueue = []

      const makePreview = file => {
        running++

        // eslint-disable-next-line no-unused-vars
        this.getFilePreview(file).then(result => {
          running--
          if (filesQueue.length > 0) {
            makePreview(filesQueue.shift())
          }
        })
      }

      const enqueuePreview = file => {
        filesQueue.push(file)
      }

      return {
        push: file =>
          running < concurrency ? makePreview(file) : enqueuePreview(file)
      }
    },

    submitFile(file) {
      file.uploadStatus = 'getting_signed_url'
      this.updateProperties(file)

      const awsService = axios.create({
        baseURL: 'https://72h47exhvc.execute-api.eu-central-1.amazonaws.com/',

        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      })

      awsService
        .post('/production/getpresignedurl', null, {
          params: {
            filePath: file.name,
            contentType: file.file.type
          }
        })
        .then(response => {
          file.uploadStatus = 'start_uploading'
          this.updateProperties(file)
          const presigned_post = response.data

          const config = {
            headers: {
              'Content-Type': file.file.type
            },

            onUploadProgress: progressEvent => {
              file.uploadProgress = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              )
              this.updateProperties(file)
            }
          }

          axios
            .put(presigned_post.url, file.file, config)

            // eslint-disable-next-line no-unused-vars
            .then(response => {
              this.uploadComplete(file)
            })
            .catch(error => {
              file.uploadStatus = 'error_uploading'
              file.errorMessage = error
              this.updateProperties(file)
            })
        })
        .catch(error => {
          file.uploadStatus = 'error_getting_signed_url'
          file.errorMessage = error
          this.updateProperties(file)
        })
    },

    handleFileUploads() {
      let selectedFiles = this.$refs.files.getFiles()
      let startIndex = this.uploadStartingFromIndex
      let pQueue = this.previewsQueue(1)
      for (var i = 0; i < selectedFiles.length; i++) {
        let fileData = selectedFiles[i]
        let fileDataArray = fileData.name.split('.')
        let ext = fileDataArray.pop()
        let file = {
          text: '',
          name: fileDataArray.join('.') + '_' + getRandomString(6) + '.' + ext,
          file: fileData
        }
        this.files.splice(startIndex++, 0, file)
        pQueue.push(file)
        this.submitFile(file)
      }
    }
  }
}
